import { useEffect, useState } from "react";
import api from "@/lib/api";

// Module-level cache so every page/section shares one fetch of /page-content.
let _cache = null;
let _promise = null;
let _listeners = [];

function _emit() { _listeners.forEach((f) => f(_cache)); }

export function refreshPageContent() {
  _promise = api.get("/page-content").then((r) => { _cache = r.data; _emit(); return _cache; }).catch(() => null);
  return _promise;
}

export function setPageContent(data) { _cache = data; _emit(); }

export function usePageContent() {
  const [c, setC] = useState(_cache);
  useEffect(() => {
    const f = (v) => setC(v);
    _listeners.push(f);
    if (_cache) setC(_cache);
    else if (!_promise) refreshPageContent();
    return () => { _listeners = _listeners.filter((x) => x !== f); };
  }, []);
  return c;
}
